import { PersistentWallOfShameAPIKey } from '../helpers/PersistentWallOfShameAPIKey';

export type WOSAPIUser = {
  id: number;
  name: string;
  reason: string;
  unban_ts: number;
  banned_since: number;
};

class WallOfShameService {
  load_all = () =>
    fetch('/wall-of-shame/users/')
      .then(response => response.json())
      .then(json => json as WOSAPIUser[]);

  create = (payload: Omit<WOSAPIUser, 'id'>) => {
    type Result = {
      result: {
        new: boolean;
        user: WOSAPIUser;
      };
    };

    return fetch(`/wall-of-shame/users/?k=${PersistentWallOfShameAPIKey.get()}`, {
      method: 'PUT',
      body: JSON.stringify({
        name: payload.name,
        reason: payload.reason,
        unban_ts: payload.unban_ts,
        banned_since: payload.banned_since,
      }),
    })
      .then(response => response.json())
      .then(json => (json as Result).result)
      .catch(() => null);
  };

  save = (id: number, payload: Omit<WOSAPIUser, 'id'>) => {
    type Result = {
      result: {
        new: boolean;
        user: WOSAPIUser;
      };
    };

    return fetch(`/wall-of-shame/users/${id}/?k=${PersistentWallOfShameAPIKey.get()}`, {
      method: 'PATCH',
      body: JSON.stringify({
        name: payload.name,
        reason: payload.reason,
        unban_ts: payload.unban_ts,
        banned_since: payload.banned_since,
      }),
    })
      .then(response => response.json())
      .then(json => (json as Result).result)
      .catch(() => null);
  };

  delete = (id: number) =>
    fetch(`/wall-of-shame/users/${id}/?k=${PersistentWallOfShameAPIKey.get()}`, {
      method: 'DELETE',
    })
      .then(response => response.json())
      .then(json => json as boolean)
      .catch(() => null);
}

export const WallOfShame = new WallOfShameService();
